<template>
  <div>
    <!--<base-header></base-header>-->
    <div class="container">
      <form @submit.prevent="save">
        <div class="form-header" v-if="id">{{$t('editSIP.editHeader')}}</div>
        <div class="form-header" v-else>{{$t('editSIP.addHeader')}}</div>
        <div class="form-group">
          <input type="text" class="form-control" v-model="username" :placeholder="$t('editSIP.username')" :class="{'form-error': errorMessage['username']}" autocomplete="off" />
          <p v-for="msg in errorMessage['username']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="password" class="form-control" v-model="password" :placeholder="$t('editSIP.password')" :class="{'form-error': errorMessage['password']}" autocomplete="new-password" />
          <p v-for="msg in errorMessage['password']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <div class="input-group">
            <input type="text" class="form-control" v-model="domain" :placeholder="$t('editSIP.domain')" :class="{'form-error': errorMessage['domain']}" autocomplete="off" />
            <div class="input-group-append">
              <span class="" id="">.CCALL.VN</span>
            </div>
          </div>
          <p v-for="msg in errorMessage['domain']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group text-center btn-submit">


        <div class="row">
          <div class="col-xs-6">
            <div class="form-group text-right btn-submit">
              <base-button type="button" class="btn-block btn-default" @click="goBack()">{{$t('edit.cancel')}}</base-button>
            </div>
          </div>

          <div class="col-xs-6">
            <div class="form-group text-right btn-submit">
              <base-button type="submit" class="btn-block">{{$t('editSIP.save')}}</base-button>
            </div>
          </div>

          <div class="clearfix"></div>

        </div>

        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Slide from '../components/Slide';
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";

  export default {
    components: {
      BaseHeader,
      BaseButton,
      Slide,
    },
    name: 'EditSipPage',
    props: {
      id: {
        type: [Number, String],
        required: false
      },
    },
    data() {
      return {
        username: '',
        password: '',
        domain: '',
        errorMessage: [],
        isActive: 1,
      };
    },
    methods: {
      save() {
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('username', this.username);
        formData.append('password', this.password);
        formData.append('domain', this.domain);
        formData.append('id', this.id);
        this.axios.post('/saveSip?token=' + token, formData).then(response => {
          if (response.data.status) {
            if (response.data.active) {
              top.window.location.href = response.data.data.url;
            }
            this.$router.push({name: 'EditPage', params: {sip_create: response.data.create, sip_update: response.data.update}});
          } else {
            this.errorMessage = response.data.data;
          }
        })
      },
      goBack() {
        if (window.history.length > 0) {
          if (this.id) {
            this.$router.push({name: 'EditPage'});
          } else {
            window.history.back();
          }
        } else {
          this.$router.push({name: 'EditPage'});
        }
      }
    },
    mounted() {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push({name: 'LoginPage'});
      }
      if (this.id) {
        this.axios.get('/sipInfo/' + this.id + '?token=' + token).then(response => {
          if (response.data.status) {
            this.username = response.data.data.sip_username;
            this.password = response.data.data.sip_password;
            this.isActive = response.data.data.status;
            this.domain = response.data.data.sip_domain.replace(/\.ccall\.vn$/, '');
          } else {
            this.$router.push({name: 'EditPage'});
          }
        })
      }
    }
  };
</script>
<style scoped="">
</style>



// WEBPACK FOOTER //
// src/pages/EditSipPage.vue